import React from 'react';
import { useParams } from 'react-router-dom';
import { useGetUserQuery } from '../../../api/queries/getUser';
import { useListRolesQuery } from '../../../api/queries/listRoles';
import { useListUserGroupsQuery } from '../../../api/queries/listUserGroups';
import { useCompany } from '../../../components/contexts/CompanyContextManager';
import LoadingElement from '../../../components/LoadingElement';
import NotFoundResult from '../../../components/results/NotFoundResult';
import UserDetailsInnerPage from './UserDetailsInnerPage';

export type UserDetailsPageProps = {
    disabled?: boolean;
};

const UserDetailsPage = ({ disabled = false }: UserDetailsPageProps) => {
    const { userId } = useParams<{ userId: string }>();
    const company = useCompany(true);

    const { data, loading } = useGetUserQuery({
        fetchPolicy: 'network-only',
        variables: { userId },
    });

    // Fetch list of roles that based on permission
    const { data: dataRoles, loading: roleLoading } = useListRolesQuery({
        fetchPolicy: 'cache-and-network',
        variables: { filter: { companyId: company?.id } },
    });

    // Fetch list of user group that based on permission
    const { data: dataUserGroup, loading: userGroupLoading } = useListUserGroupsQuery({
        fetchPolicy: 'cache-and-network',
        variables: { filter: { companyId: company?.id } },
    });

    const user = data?.user;

    if (!user && (loading || roleLoading || userGroupLoading)) {
        return <LoadingElement />;
    }

    if (!user) {
        return <NotFoundResult />;
    }

    return (
        <UserDetailsInnerPage
            allowedRoles={dataRoles?.page?.items ?? []}
            allowedUserGroups={dataUserGroup?.page?.items ?? []}
            disabled={disabled}
            user={user}
        />
    );
};

export default UserDetailsPage;
